import { HttpInterceptorFn } from "@angular/common/http";

export const AutoSaveHeader = "X-Is-AutoSave";

export const autoSaveInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.body != null && typeof req.body === "object" && "__$autoSave$__" in req.body) {
        req = req.clone({ headers: req.headers.set(AutoSaveHeader, "true") });
    }
    return next(req);
};
